/*
 * Rough Magnitude Calculator (rmcalc) - Shopify asset
 *
 * Upload this file to Assets in the theme code editor (Assets > Add a new
 * asset), then reference it from theme.liquid with:
 *   {% if page.handle == 'pricing' %}
 *     <script src="{{ 'rmcalc.js' | asset_url }}" defer></script>
 *   {% endif %}
 * That's the only include needed - this file injects its own CSS at
 * runtime (see RM_CSS below), so no separate stylesheet asset or <link>
 * tag is required.
 *
 * This is a JS port of pricing.py from the internal Flask tool. Keep it in
 * sync by hand - there is no shared source between this file and pricing.py.
 */
(function () {
  "use strict";

  // Exact brand colors as given: background #171C23, accent text (e.g.
  // "Total Price") #C9A84C, body text #F8F9FA. --rmcalc-muted and
  // --rmcalc-field-bg are derived from --rmcalc-text at low opacity rather
  // than invented separately, so everything ties back to just these three.
  var RM_CSS = "#rmcalc-root, #rmcalc-root * { box-sizing: border-box; }\n" +
    "#rmcalc-root {\n" +
    "  --rmcalc-border: rgba(248, 249, 250, 0.16);\n" +
    "  --rmcalc-accent: #C9A84C;\n" +
    "  --rmcalc-accent-text: #171C23;\n" +
    "  --rmcalc-text: #F8F9FA;\n" +
    "  --rmcalc-muted: rgba(248, 249, 250, 0.62);\n" +
    "  --rmcalc-field-bg: rgba(248, 249, 250, 0.05);\n" +
    "  max-width: 640px;\n" +
    "  margin: 2rem auto;\n" +
    "  padding: 0;\n" +
    "  color: var(--rmcalc-text);\n" +
    "}\n" +
    "#rmcalc-root h1 { font-size: 1.5rem; margin: 0 0 1.25rem; font-weight: 600; color: var(--rmcalc-text); }\n" +
    "#rmcalc-root .rmcalc-tabs {\n" +
    "  display: flex; gap: 1.75rem; margin-bottom: 1.5rem;\n" +
    "  border-bottom: 1px solid var(--rmcalc-border);\n" +
    "}\n" +
    "#rmcalc-root .rmcalc-tab-btn {\n" +
    "  background: none; border: none; padding: 0 0 0.7rem; cursor: pointer;\n" +
    "  font-size: 0.8rem; color: var(--rmcalc-muted); border-bottom: 2px solid transparent;\n" +
    "  text-transform: uppercase; letter-spacing: 0.05em; font-weight: 600;\n" +
    "}\n" +
    "#rmcalc-root .rmcalc-tab-btn.active {\n" +
    "  color: var(--rmcalc-accent); border-bottom-color: var(--rmcalc-accent);\n" +
    "}\n" +
    "#rmcalc-root .rmcalc-panel { display: none; }\n" +
    "#rmcalc-root .rmcalc-panel.active { display: block; }\n" +
    "#rmcalc-root label {\n" +
    "  display: block; font-weight: 600; margin: 1.1rem 0 0.4rem; font-size: 0.75rem;\n" +
    "  color: var(--rmcalc-muted); text-transform: uppercase; letter-spacing: 0.05em;\n" +
    "}\n" +
    "#rmcalc-root textarea, #rmcalc-root input[type=\"number\"] {\n" +
    "  width: 100%; padding: 0.65rem 0.8rem; border: 1px solid var(--rmcalc-border);\n" +
    "  border-radius: 4px; font-family: inherit; font-size: 0.95rem;\n" +
    "  background: var(--rmcalc-field-bg); color: var(--rmcalc-text);\n" +
    "}\n" +
    "#rmcalc-root textarea::placeholder, #rmcalc-root input::placeholder { color: var(--rmcalc-muted); }\n" +
    "#rmcalc-root textarea { resize: vertical; }\n" +
    "#rmcalc-root .rmcalc-status { font-size: 0.82rem; margin: 0.4rem 0 0.5rem; min-height: 1.1em; }\n" +
    "#rmcalc-root .rmcalc-status.error { color: #e08585; }\n" +
    "#rmcalc-root .rmcalc-status.ok { color: #8fce9c; }\n" +
    "#rmcalc-root .rmcalc-live-counts { display: flex; gap: 1.5rem; font-size: 0.85rem; color: var(--rmcalc-muted); margin-top: 0.6rem; flex-wrap: wrap; }\n" +
    "#rmcalc-root .rmcalc-live-counts b { color: var(--rmcalc-text); }\n" +
    "#rmcalc-root input[id$=\"-rules\"] { max-width: 120px; }\n" +
    "#rmcalc-root button.rmcalc-calc-btn {\n" +
    "  margin-top: 1.5rem; background: var(--rmcalc-accent); color: var(--rmcalc-accent-text); border: none;\n" +
    "  padding: 0.75rem 1.6rem; border-radius: 999px; font-size: 0.82rem; font-weight: 700;\n" +
    "  cursor: pointer; text-transform: uppercase; letter-spacing: 0.05em;\n" +
    "}\n" +
    "#rmcalc-root button.rmcalc-calc-btn:hover { filter: brightness(1.12); }\n" +
    "#rmcalc-root button:disabled { opacity: 0.5; cursor: not-allowed; }\n" +
    "#rmcalc-root table.rmcalc-result { margin-top: 1.75rem; width: 100%; border-collapse: collapse; }\n" +
    "#rmcalc-root table.rmcalc-result td { border: 1px solid var(--rmcalc-border); padding: 0.65rem 0.85rem; font-size: 0.88rem; color: var(--rmcalc-text); }\n" +
    "#rmcalc-root table.rmcalc-result td:last-child { text-align: right; }\n" +
    "#rmcalc-root table.rmcalc-result tr.rmcalc-total td { font-weight: 700; background: rgba(201, 168, 76, 0.12); color: var(--rmcalc-accent); }\n";

  if (!document.getElementById("rmcalc-styles")) {
    var styleEl = document.createElement("style");
    styleEl.id = "rmcalc-styles";
    styleEl.textContent = RM_CSS;
    document.head.appendChild(styleEl);
  }

  /* ============================================================
   * RM_PRICING - JS port of pricing.py.
   * ============================================================ */
  var RM_PRICING = (function () {
  
    // Per-unit prices (USD) - updated per DWD Schedule A.
    var RULE_PRICE = 58.14;       // Variable: m
    var SENTENCE_PRICE = 116.28;  // Variable: s
    var PUNCTUATION_PRICE = 8.72; // Variable: p
    var COLUMN_PRICE = 87.21;     // Variable: c
    var ROW_PRICE = 5.81;         // Variable: r  

    // Bullet codepoints: 0x2022 bullet, 0x25AA black small square,
    // 0x25E6 white bullet, 0x2023 triangular bullet. Built from character
    // codes (not typed literally) so this runs correctly regardless of the
    // host page's declared charset - a Shopify asset file's encoding isn't
    // something this snippet controls.
    var BULLET_CHARS = "-*" + String.fromCharCode(0x2022, 0x25AA, 0x25E6, 0x2023);
    var BULLET_LINE_RE_G = new RegExp("^\\s*(?:[" + BULLET_CHARS + "]|\\d+[.)]|[a-zA-Z][.)])\\s+", "gm");
    var BULLET_LINE_RE_ANCHOR = new RegExp("^\\s*(?:[" + BULLET_CHARS + "]|\\d+[.)]|[a-zA-Z][.)])\\s+");
    var SENTENCE_SPLIT_RE = /(?<=[.!?])\s+/;
    var WORD_RE = /\S+/g;
    var RUN_RESET_CHARS = ",:)";
    var SENTENCE_END_CHARS = ".!?";
    var INFER_RUN_THRESHOLD = 15;

    function countSourceSentences(text) {
      text = text.trim();
      if (!text) return 0;
      var parts = text.split(SENTENCE_SPLIT_RE);
      var count = 0;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].trim()) count++;
      }
      return count;
    }

    function countSourcePunctuation(text) {
      var commas = (text.match(/,/g) || []).length;
      var colons = (text.match(/:/g) || []).length;
      var parens = (text.match(/\)/g) || []).length;
      var bullets = (text.match(BULLET_LINE_RE_G) || []).length;
      return {
        commas: commas,
        colons: colons,
        parens: parens,
        bullets: bullets,
        total: commas + colons + parens + bullets,
      };
    }

    // Same run-length algorithm and check ORDER as pricing.py's
    // count_inferred_punctuation: check reset-chars first (a comma/colon/paren
    // in the word satisfies the run outright), THEN check the threshold, THEN
    // check for a sentence-ender (which delimits the run but must have already
    // cleared the threshold check - a sentence ending exactly on word 16 still
    // triggers an inference; only reset-chars give a free pass).
    function countInferredPunctuation(text) {
      var inferred = 0;
      var runLength = 0;
      var lines = text.split("\n");

      for (var li = 0; li < lines.length; li++) {
        var line = lines[li];
        if (BULLET_LINE_RE_ANCHOR.test(line)) {
          runLength = 0;
        }
        var words = line.match(WORD_RE) || [];
        for (var wi = 0; wi < words.length; wi++) {
          var word = words[wi];
          runLength += 1;

          var hasResetChar = false;
          for (var ci = 0; ci < word.length; ci++) {
            if (RUN_RESET_CHARS.indexOf(word[ci]) !== -1) { hasResetChar = true; break; }
          }
          if (hasResetChar) {
            runLength = 0;
            continue;
          }
          if (runLength > INFER_RUN_THRESHOLD) {
            inferred += 1;
            runLength = 0;
          }
          if (SENTENCE_END_CHARS.indexOf(word[word.length - 1]) !== -1) {
            runLength = 0;
          }
        }
      }
      return inferred;
    }

    function scanText(text) {
      var punctuation = countSourcePunctuation(text);
      var inferred = countInferredPunctuation(text);
      var breakdown = {
        commas: punctuation.commas,
        colons: punctuation.colons,
        parens: punctuation.parens,
        bullets: punctuation.bullets,
        inferred: inferred,
      };
      return {
        sentences: countSourceSentences(text),
        punctuation: punctuation.total + inferred,
        punctuationBreakdown: breakdown,
      };
    }

    function priceText(text, rules) {
      var scan = scanText(text);
      var ruleCost = rules * RULE_PRICE;
      var sentenceCost = scan.sentences * SENTENCE_PRICE;
      var punctuationCost = scan.punctuation * PUNCTUATION_PRICE;
      var total = ruleCost + sentenceCost + punctuationCost;

      return {
        counts: { rules: rules, sentences: scan.sentences, punctuation: scan.punctuation },
        lineItems: [
          { label: "Metadata (price per rule)", unitPrice: RULE_PRICE, count: rules, cost: ruleCost },
          { label: "Source sentences", unitPrice: SENTENCE_PRICE, count: scan.sentences, cost: sentenceCost },
          { label: "Source internal punctuation (commas, colons, list bullets, closing parentheses, inferred marks)", unitPrice: PUNCTUATION_PRICE, count: scan.punctuation, cost: punctuationCost },
        ],
        total: Math.round(total * 100) / 100,
      };
    }

    function splitRows(tableText) {
      return tableText.split("\n").filter(function (line) { return line.trim() !== ""; });
    }

    function splitColumns(line) {
      var cells = line.indexOf("\t") !== -1 ? line.split("\t") : line.split(",");
      return cells.filter(function (c) { return c.trim() !== ""; });
    }

    function scanTable(tableText) {
      var rows = splitRows(tableText);
      if (rows.length === 0) return { rows: 0, columns: 0 };
      var columns = 0;
      for (var i = 0; i < rows.length; i++) {
        var n = splitColumns(rows[i]).length;
        if (n > columns) columns = n;
      }
      return { rows: rows.length, columns: columns };
    }

    function priceTable(tableText, rules) {
      var scan = scanTable(tableText);
      var ruleCost = rules * RULE_PRICE;
      var columnCost = scan.columns * COLUMN_PRICE;
      var rowCost = scan.rows * ROW_PRICE;
      var total = ruleCost + columnCost + rowCost;

      return {
        counts: { rules: rules, columns: scan.columns, rows: scan.rows },
        lineItems: [
          { label: "Metadata (price per rule)", unitPrice: RULE_PRICE, count: rules, cost: ruleCost },
          { label: "Source table columns", unitPrice: COLUMN_PRICE, count: scan.columns, cost: columnCost },
          { label: "Source table rows", unitPrice: ROW_PRICE, count: scan.rows, cost: rowCost },
        ],
        total: Math.round(total * 100) / 100,
      };
    }

    return { scanText: scanText, priceText: priceText, scanTable: scanTable, priceTable: priceTable };
  })();

  /* ============================================================
   * UI wiring
   * ============================================================ */
  function byId(id) { return document.getElementById(id); }

  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, delay);
    };
  }

  function setStatus(el, message, kind) {
    el.textContent = message;
    el.className = "rmcalc-status" + (kind ? " " + kind : "");
  }
   
   // 0x00D7 multiplication sign, 0x0024 dollar sign - built from codepoints
   // rather than typed literally so rendering never depends on the host
   // page's charset declaration.
   var TIMES = String.fromCharCode(0x00D7);
   var USD = String.fromCharCode(0x0024);

  function renderResult(tableEl, lineItems, total) {
    var tbody = tableEl.querySelector("tbody");
    tbody.innerHTML = "";
    for (var i = 0; i < lineItems.length; i++) {
      var item = lineItems[i];
      var row = document.createElement("tr");
      row.innerHTML = "<td>" + item.label + " (" + item.count + " " + TIMES + " " + USD + item.unitPrice.toFixed(2) + ")</td><td>" + USD + item.cost.toFixed(2) + "</td>";
      tbody.appendChild(row);
    }
    var totalRow = document.createElement("tr");
    totalRow.className = "rmcalc-total";
    totalRow.innerHTML = "<td>Total Price</td><td>" + USD + total.toFixed(2) + "</td>";
    tbody.appendChild(totalRow);
    tableEl.hidden = false;
  }

  // Tabs
  var tabBtns = document.querySelectorAll("#rmcalc-root .rmcalc-tab-btn");
  for (var t = 0; t < tabBtns.length; t++) {
    tabBtns[t].addEventListener("click", function () {
      for (var j = 0; j < tabBtns.length; j++) tabBtns[j].classList.remove("active");
      var panels = document.querySelectorAll("#rmcalc-root .rmcalc-panel");
      for (var k = 0; k < panels.length; k++) panels[k].classList.remove("active");
      this.classList.add("active");
      byId("rmcalc-tab-" + this.dataset.tab).classList.add("active");
    });
  }

  // Text mode
  var textInput = byId("rmcalc-text-input");
  var textSentences = byId("rmcalc-text-sentences");
  var textPunct = byId("rmcalc-text-punct");
  var textRules = byId("rmcalc-text-rules");
  var textResult = byId("rmcalc-text-result");
  var textCalcBtn = byId("rmcalc-text-calc");
  var textStatus = byId("rmcalc-text-status");

  var updateTextLiveCounts = debounce(function () {
    var scan = RM_PRICING.scanText(textInput.value);
    textSentences.textContent = scan.sentences;
    textPunct.textContent = scan.punctuation;
  }, 200);
  textInput.addEventListener("input", updateTextLiveCounts);

  textCalcBtn.addEventListener("click", function () {
    if (!textInput.value.trim()) {
      setStatus(textStatus, "Source text is empty - paste text before calculating.", "error");
      return;
    }
    setStatus(textStatus, "", "");
    var rules = Number(textRules.value) || 0;
    var result = RM_PRICING.priceText(textInput.value, rules);
    renderResult(textResult, result.lineItems, result.total);
  });

  // Table mode
  var tableInput = byId("rmcalc-table-input");
  var tableColumns = byId("rmcalc-table-columns");
  var tableRows = byId("rmcalc-table-rows");
  var tableRules = byId("rmcalc-table-rules");
  var tableResult = byId("rmcalc-table-result");
  var tableCalcBtn = byId("rmcalc-table-calc");

  var updateTableLiveCounts = debounce(function () {
    var scan = RM_PRICING.scanTable(tableInput.value);
    tableColumns.textContent = scan.columns;
    tableRows.textContent = scan.rows;
  }, 200);
  tableInput.addEventListener("input", updateTableLiveCounts);

  var tableStatus = byId("rmcalc-table-status");

  tableCalcBtn.addEventListener("click", function () {
    if (!tableInput.value.trim()) {
      setStatus(tableStatus, "Source table is empty - paste table data before calculating.", "error");
      return;
    }
    setStatus(tableStatus, "", "");
    var rules = Number(tableRules.value) || 0;
    var result = RM_PRICING.priceTable(tableInput.value, rules);
    renderResult(tableResult, result.lineItems, result.total);
  });
})();